/** @jsx jsx */
import { css, jsx } from '@emotion/core';

const footerCss = css`
  background-color: #000;
  padding: 4em 10px;
  text-align: center;
`;

const wrapperCss = css`
  margin: 0 auto;
  max-width: 860px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  > a {
    width: 100px;
    height: 50px;
    margin: 20px 10px;
    > img {
      opacity: 0.2;
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }
`;

const Footer = ({ clients }) => {
  return (
    <footer css={footerCss}>
      <div css={wrapperCss}>
        {clients.map(({ logo, url }, index) => {
          const imgName = logo.url.split('-').pop();
          return (
            <a key={index} target="_blank" rel="noopener noreferrer" href={url}>
              <img src={`/img/${imgName}`} alt={imgName} />
            </a>
          );
        })}
      </div>
    </footer>
  );
};

export default Footer;
